var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25105 0.894455C7.86053 0.503931 7.22736 0.503931 6.83684 0.894455L0.472877 7.25842C0.0823524 7.64894 0.0823524 8.28211 0.472877 8.67263C0.863401 9.06315 1.49657 9.06315 1.88709 8.67263L7.54394 3.01578L13.2008 8.67263C13.5913 9.06315 14.2245 9.06315 14.615 8.67263C15.0055 8.28211 15.0055 7.64894 14.615 7.25842L8.25105 0.894455ZM8.54395 23.6016L8.54394 1.60156L6.54394 1.60156L6.54395 23.6016L8.54395 23.6016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.a5c6596db32982470b6744cc5d2b4158.svg";
export { ForwardRef as ReactComponent };